import axiosConfig from "./axiosConfig";

export interface SimStatus {
  imsi: string;
  online: boolean;
  ue_ip_address: string | null;
  imei: string | null;
}

export interface SimStatusResponse {
  site_id: string;
  esys_uuid: string;
  sim_status: SimStatus;
}

const getSimStatus = async (
  authToken: string,
  siteId: string,
  esysUuid: string
): Promise<SimStatusResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/ingestion/soracom/sim_status`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      params: { esysUuid },
    }
  );
  return data;
};

export default getSimStatus;
